export default __webpack_public_path__ + "static/media/LobbySound2_Loop.7f0e6687.wav";